import Request from './baseRequest'

  const getUserToken = () => {
    return JSON.parse(localStorage.getItem('auth.currentUser')).token;
  }
  
  const _createTemplate = payload => {
  
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.post(
      `${window.config.VUE_APP_BACKEND}/api/content-templates`,
      payload,
      config
    )
  }
  
  const _getTemplates = params => { 
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    const url= params? `${window.config.VUE_APP_BACKEND}/api/content-templates?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/content-templates`
  
  
    return Request.get(
      url,
      config
    )
  }
  
  const _deleteTemplate = templateId => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.delete(`${window.config.VUE_APP_BACKEND}/api/content-templates/${templateId}`, config)
  }
  
  const _getTemplate = templateId => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.get(`${window.config.VUE_APP_BACKEND}/api/content-templates/${templateId}`, config)
  }
  
  const _updateTemplate = (template) => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.put(`${window.config.VUE_APP_BACKEND}/api/content-templates/${template._id}`, template, config)
  }

  const _updateTemplateStore = (template) => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.put(`${window.config.VUE_APP_BACKEND}/api/template-stores/${template._id}`, template, config)
  }

  const _getTemplatesStore = params => { 
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    const url= params? `${window.config.VUE_APP_BACKEND}/api/template-stores?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/template-stores`
  
    return Request.get(
      url,
      config
    )
  }

  // Plantilla del store completa (con `value`): la lista se pide sin ese campo.
  const _getTemplateStore = id => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }

    return Request.get(`${window.config.VUE_APP_BACKEND}/api/template-stores/${id}`, config)
  }

  const _createTemplateStore = payload => {
  
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.post(
      `${window.config.VUE_APP_BACKEND}/api/template-stores`,
      payload,
      config
    )
  }

  

  export default {
        createTemplate: _createTemplate,
        updateTemplate: _updateTemplate,
        getTemplate : _getTemplate,
        getTemplates: _getTemplates,
        deleteTemplate : _deleteTemplate,
        getTemplatesStore : _getTemplatesStore,
        updateTemplateStore: _updateTemplateStore,
        createTemplateStore: _createTemplateStore,
        getTemplateStore: _getTemplateStore
  };


